'use client'

import Link from 'next/link'
import { useEffect } from 'react'

export default function BlogError({ error, reset }) {
  useEffect(() => {
    console.error('[BlogError]', error)
  }, [error])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-sm w-full bg-white rounded-2xl shadow-md p-8 text-center">
        <div className="text-4xl mb-4">✈️</div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">This page hit turbulence</h2>
        <p className="text-gray-500 text-sm mb-6">
          We couldn't load this article. The rest of the site is fine — try a refresh or head back to our blog.
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={reset}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg px-4 py-2.5 transition-colors text-sm"
          >
            Try again
          </button>
          <Link
            href="/blog"
            className="w-full block bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg px-4 py-2.5 transition-colors text-sm text-center"
          >
            Back to blog
          </Link>
          <Link
            href="/"
            className="text-sm text-gray-400 hover:text-gray-600 transition-colors mt-1"
          >
            Go to homepage
          </Link>
        </div>
      </div>
    </div>
  )
}
